import { defineStyle, defineStyleConfig } from '@chakra-ui/react';

const baseStyle = defineStyle({
  color: 'green.600',
});

export const SpinnerStyles = defineStyleConfig({
  baseStyle,
  defaultProps: {
    size: 'lg',
  },
});
